<template>
  <component
    :is="component"
    class="ui-hover-group"
    :class="{ 'is-active': active }"
    v-bind="componentAttributes"
    v-on="$listeners"
    @dragstart.prevent
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'UiHoverGroup',
  inheritAttrs: false,

  props: {
    tag: {
      type: String,
      default: 'div'
    },
    to: {
      type: [String, Object],
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    component () {
      if (this.to) return 'router-link'
      if (this.href) return 'a'
      return this.tag
    },

    componentAttributes () {
      const attributes = { ...this.$attrs }
      if (this.to) attributes.to = this.to
      if (this.href) attributes.href = this.href
      if (this.to || this.href) attributes.draggable = 'false'
      return attributes
    }
  }
}
</script>

<style lang="scss">
.ui-hover-group {
  -webkit-user-drag: none;

  &__media {
    display: block;
    overflow: hidden;
  }

  &__media img,
  &__media video,
  &__media .ui-hover-group__media-content {
    transition: transform 0.9s ease-out;
    user-select: none;
    -webkit-user-drag: none;
  }

  &:hover,
  &:active,
  &.is-active {
    .ui-hover-group__media img,
    .ui-hover-group__media video,
    .ui-hover-group__media .ui-hover-group__media-content {
      transform: scale(1.03);
    }
  }
}
</style>
